import script from "./FormCheckList.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormCheckList.vue?vue&type=script&setup=true&lang=ts"

import "./FormCheckList.vue?vue&type=style&index=0&id=349242fc&lang=scss"

const __exports__ = script;

export default __exports__